import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
 clearCachesAndReloadForNewDeployment,
 getChunkRecoveryReloadAttempts,
} from 'helpers/chunkLoadRecovery'

const MAX_HINT_RELOADS = 3

type Props = {
 isOffline: boolean
 /** Soft retry (re-import chunks without full reload) */
 retryingSoft: boolean
 onSoftRetry: () => void
}

export function ChunkLoadRecoveryPanel({ isOffline, retryingSoft, onSoftRetry }: Props) {
 const navigate = useNavigate()
 const attempts = getChunkRecoveryReloadAttempts()
 const blocked = attempts >= MAX_HINT_RELOADS

 const onHardRefresh = async () => {
 void clearCachesAndReloadForNewDeployment()
 }

 return (
 <div className="flex flex-col items-center justify-center min-h-[50vh] p-8 text-center" dir="rtl">
 <div className="w-16 h-16 mb-4 rounded-full bg-amber-100 dark:bg-amber-950 flex items-center justify-center">
 <svg className="w-8 h-8 text-amber-600 dark:text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636a9 9 0 010 12.728M5.636 18.364a9 9 0 010-12.728M12 2v4m0 12v4m-7.071-3.929l2.828-2.828m8.486-8.486l2.828-2.828M2 12h4m12 0h4m-3.929 7.071l-2.828-2.828M7.757 7.757L4.929 4.929"/>
 </svg>
 </div>

 <h3 className="text-lg font-semibold text-foreground mb-2">
 {blocked ? 'تعذر إكمال التحديث من المتصفّح' : 'تم إصدار نسخة جديدة من النظام. يرجى تحديث الصفحة للمتابعة.'}
 </h3>

 <p className="text-muted-foreground mb-2 max-w-md">
 {blocked
 ? 'تم تجاوز عدد محاولات مسح الذاكرة المؤقتة في هذه الجلسة. جرّب نافذة تصفّح خاص، أو مسح بيانات الموقع لهذا النطاق، أو تواصل مع الدعم الفني.'
 : isOffline
 ? 'أنت غير متصل بالإنترنت. عند عودة الاتصال اضغط «تحديث الآن» لإعادة التحميل.'
 : 'إذا ظهر هذا بعد نشر نسخة جديدة، يمسح التحديث الذاكرة المؤقتة ويعيد تحميل التطبيق بدون دوران لا نهائي.'}
 </p>

 <div className="flex flex-wrap items-center justify-center gap-3 mt-4">
 {!blocked ? (
 <button
 type="button" onClick={onHardRefresh}
 disabled={isOffline}
 className="px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary-hover transition-colors disabled:pointer-events-none disabled:">
 تحديث الآن
 </button>
 ) : null}
 <button
 type="button" onClick={onSoftRetry}
 disabled={retryingSoft || isOffline}
 className="px-4 py-2 border border-border rounded-lg hover:bg-muted transition-colors disabled:">
 {retryingSoft ? 'جارٍ التحميل...' : 'إعادة المحاولة'}
 </button>
 {!blocked ? (
 <button
 type="button" onClick={() => navigate('/')}
 className="px-4 py-2 border border-border rounded-lg hover:bg-muted transition-colors">
 العودة للرئيسية
 </button>
 ) : (
 <button
 type="button" onClick={() => window.location.reload()}
 className="px-4 py-2 border border-border rounded-lg hover:bg-muted transition-colors">
 إعادة تحميل عادية
 </button>
 )}
 </div>
 </div>
 )
}
